var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPerson24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8C15 10.21 13.21 12 11 12C8.79 12 7 10.21 7 8C7 5.79 8.79 4 11 4C13.21 4 15 5.79 15 8ZM11.14 19.14L12 20H3V18C3 15.34 8.33 14 11 14C11.32 14 11.61 14.02 12 14.06L11.16 14.88C9.97 16.04 9.96 17.96 11.14 19.14Z",
    fill: "#0033AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.18 19.78C15.79 20.17 15.15 20.17 14.76 19.78L12.69 17.69C12.31 17.3 12.31 16.68 12.69 16.3L12.7 16.29C13.09 15.9 13.72 15.9 14.1 16.29L15.47 17.66L19.9 13.2C20.29 12.81 20.92 12.81 21.31 13.2L21.32 13.21C21.7 13.6 21.7 14.22 21.32 14.6L16.18 19.78Z",
    fill: "#0033AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPerson24Px);
export default __webpack_public_path__ + "static/media/ic_person_24px.ccb18f9aed80f0f1d848e2fc5887537d.svg";
export { ForwardRef as ReactComponent };